import { Divider, Flex, Skeleton } from '@chakra-ui/react';

interface GoalLoadingCellProps {
  goalScope: 'CONTRIBUTOR' | 'TEAM';
  rowHeight?: string;
}

const GoalLoadingCell = ({ goalScope, rowHeight }: GoalLoadingCellProps) => {
  return (
    <>
      <Flex
        align="flex-start"
        justify={'start'}
        minH={
          rowHeight ||
          (goalScope === 'CONTRIBUTOR'
            ? '164px'
            : goalScope === 'TEAM'
            ? '184px'
            : '200px')
        }
        borderLeft="1px solid"
        borderColor="text.tertiary"
        p={3}
        bg="white"
        w={'full'}
        gap={8}
      >
        <Flex direction="column" gap={2} w="full">
          <Flex align="center" mb={1}>
            <Skeleton w="20px" h="20px" borderRadius="sm" mr={2} />
            <Skeleton w="60px" h="20px" />
          </Flex>
          <Skeleton w="100%" h="28px" mt={2} />
        </Flex>
      </Flex>
      <Divider />
    </>
  );
};

export default GoalLoadingCell;
